module.exports = __webpack_public_path__ + "img/menu2.cc48c51e.png";